import moment from "moment";

import {
  _11_20_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98967,
  _21_30_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98968,
  _30_MIN_INDIVIDUAL_90832,
  _45_MIN_INDIVIDUAL_90834,
  _5_10_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98966,
  CRISIS_EVAL_90839,
} from "@/constants/event";
import { allottedTimeFactory } from "@/features/calendar/utils/event";
import { timeSlotArray } from "@/features/calendar/utils/appointmentPickerUtils";
import { transformTimeSlotArray } from "@/components/Provider/ScheduleAvailability/ScheduleEvent";

import { CALL_FOCUS_OPTIONS } from "./call-focus";

export const CHECK_IN_SCHEMA = [
  {
    elementClasses: "col-12 col-lg-4",
    elementConfig: {
      label: "Outbound or Incoming",
      options: [
        { display: "Outbound", value: "Outbound" },
        { display: "Incoming", value: "Incoming" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "content.outbound_inbound",
  },
  {
    elementClasses: "col-12 col-lg-3",
    elementConfig: {
      label: "Call Date",
      placeholder: moment().format("MM/DD/YYYY"),
      type: "text",
    },
    elementType: "DatePicker",
    name: "session_date",
  },
  {
    elementClasses: "col-12 col-lg-3",
    elementConfig: {
      label: "Call Started At",
      options: transformTimeSlotArray(timeSlotArray),
      placeholder: "12:00 pm",
      sentenceCase: false,
    },
    elementType: "select",
    name: "session_from",
  },
  {
    elementClasses: "col-12 col-lg-7",
    elementConfig: {
      label: "Call CPT Code Linking",
      options: [
        {
          display: `30 Minute Individual (90832) (${allottedTimeFactory(
            _30_MIN_INDIVIDUAL_90832,
          )} minutes)`,
          value: _30_MIN_INDIVIDUAL_90832,
        },
        {
          display: `45 Minute Individual (90834) (${allottedTimeFactory(
            _45_MIN_INDIVIDUAL_90834,
          )} minutes)`,
          value: _45_MIN_INDIVIDUAL_90834,
        },
        {
          display: `Crisis Evaluation (90839) (${allottedTimeFactory(CRISIS_EVAL_90839)} minutes)`,
          value: CRISIS_EVAL_90839,
        },
        {
          display: `5-10 Min Phone Assmt. and Mgmt. (98966) (${allottedTimeFactory(
            _5_10_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98966,
          )} minutes)`,
          value: _5_10_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98966,
        },
        {
          display: `11-20 Min Phone Assmt. and Mgmt. (98967) (${allottedTimeFactory(
            _11_20_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98967,
          )} minutes)`,
          value: _11_20_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98967,
        },
        {
          display: `21-30 Min Phone Assmt. and Mgmt. (98968) (${allottedTimeFactory(
            _21_30_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98968,
          )} minutes)`,
          value: _21_30_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98968,
        },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "call_type",
  },
  {
    elementClasses: "col-12 col-lg-5",
    elementConfig: {
      label: "Purpose of Call",
      options: [
        { display: "Daily Check-in", value: "Daily Check-in" },
        { display: "Respond to call", value: "Respond to call" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "content.call_purpose",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Comment",
      placeholder: "Type comment...",
      type: "textArea",
    },
    elementType: "textarea",
    name: "content.comment",
  },
  {
    elementClasses: "col-12 col-lg-4",
    elementConfig: {
      label: "Call Outcome",
      options: [
        { display: "Attempted", value: "Attempted" },
        { display: "Completed", value: "Completed" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "content.call_outcome",
  },
  {
    elementClasses: "col-12 col-lg-4",
    elementConfig: {
      label: "Plan",
      options: [
        { display: "Call Tomorrow", value: "Call Tomorrow" },
        { display: "Prescriber Consult", value: "Prescriber Consult" },
        { display: "PCP Consult", value: "PCP Consult" },
        { display: "Other", value: "Other" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "content.plan",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Call Focus",
      options: CALL_FOCUS_OPTIONS,
      placeholder: "",
      type: "checkbox",
    },
    elementType: "input",
    name: "content.call_focus",
  },
  {
    elementClasses: "col-12 col-lg-8",
    elementConfig: {
      label: "Patient Outcome",
      placeholder: "",
      type: "text",
    },
    elementType: "input",
    name: "content.patient_outcome_answer",
  },
  {
    elementConfig: {
      label: "",
      placeholder: "",
    },
    elementType: "discharges",
    name: "content.discharges",
  },
  {
    elementClasses: "col-12 col-lg-6",
    elementConfig: {
      label: "ICD-10 Primary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_10_axis_1_diagnosis",
  },
  {
    elementClasses: "col-12 col-lg-6",
    elementConfig: {
      label: "ICD-10 Secondary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_10_axis_2_diagnosis",
  },
  {
    elementClasses: "col-12 col-lg-7",
    elementConfig: {
      classNames: "font-weight-bold",
      displayName: "Click to Sign",
      hideTopLabel: true,
      label: "Signature",
      type: "checkbox",
    },
    elementType: "input",
    name: "signature",
  },
  {
    elementClasses: "col-12 col-lg-3",
    elementConfig: {
      label: "Credentials",
      placeholder: "",
      type: "text",
    },
    elementType: "input",
    name: "provider_cp_credentials",
  },
];
